import React from 'react'
import Card from '../../../components/ui/Card'
import Icon from '../../../components/AppIcon'

const PriceDisplay = ({ prices, loading, error, onRefresh }) => {
  const formatPrice = (price) => {
    if (!price) return '—'
    return `$${price.toFixed(2)}`
  }

  return (
    <Card variant="solid" padding="none" className="rounded-xl border-[#DCDFE5] bg-white shadow-none">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b border-[#DCDFE5] px-5 py-3">
        <h2 className="text-xs font-semibold uppercase tracking-[0.08em] text-[#656C78]">Market prices</h2>
        {prices && (
          <div className="flex items-center gap-2 text-xs">
            <span className={`h-1.5 w-1.5 rounded-full ${prices.stale ? 'bg-warning' : 'bg-[#2457DB]'}`} aria-hidden="true" />
            <span className={prices.stale ? 'font-medium text-warning' : 'font-medium text-[#2457DB]'}>
              {prices.stale ? 'Stale' : 'Live'}
            </span>
            {prices.ageMinutes != null && (
              <span className="text-[#656C78]">
                · {prices.ageMinutes === 0 ? 'just now' : `${prices.ageMinutes} min ago`}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 divide-x divide-[#DCDFE5]">
        <div className="min-w-0 px-4 py-4 sm:px-5 sm:py-5">
          <p className="mb-1.5 text-sm font-medium text-[#656C78]">Gold</p>
          {loading ? (
            <div className="h-9 w-24 animate-pulse rounded bg-[#F5F6F8]" />
          ) : (
            <p className="text-2xl font-semibold leading-tight tracking-tight text-[#17191D] tabular-nums sm:text-[32px]">
              {formatPrice(prices?.gold)}
              <span className="ml-1 text-sm font-normal tracking-normal text-[#656C78]">/g</span>
            </p>
          )}
        </div>
        <div className="min-w-0 px-4 py-4 sm:px-5 sm:py-5">
          <p className="mb-1.5 text-sm font-medium text-[#656C78]">Silver</p>
          {loading ? (
            <div className="h-9 w-24 animate-pulse rounded bg-[#F5F6F8]" />
          ) : (
            <p className="text-2xl font-semibold leading-tight tracking-tight text-[#17191D] tabular-nums sm:text-[32px]">
              {formatPrice(prices?.silver)}
              <span className="ml-1 text-sm font-normal tracking-normal text-[#656C78]">/g</span>
            </p>
          )}
        </div>
      </div>

      {/* Error message */}
      {error && (
        <div className="flex items-start gap-2 border-t border-[#DCDFE5] px-5 py-3 text-sm text-warning">
          <Icon name="AlertTriangle" size={16} className="mt-0.5 shrink-0" />
          <span>{error}</span>
        </div>
      )}
    </Card>
  )
}

export default PriceDisplay
